module.exports = __webpack_public_path__ + "static/media/logo_pn_en.83576451.svg";